// 当前代码多处使用，逻辑有改动请重新写一份，不要在此处修改，否则可能影响其他页面
export default {
  data() {
    return {
      xTableData: [],  // table数据
      checkRows: [],  // 选中数据
    }
  },
  methods: {
    // 确定
    confirm() {
      this.$emit('confirm', this.checkRows)
      this.dialogClose()
    },

    // 复选框触发
    xTableChecked(data) {
      console.log('复选框变化', data)
      let temp = []
      temp.push(...data.records)
      temp.push(...data.reserves)
      this.checkRows = temp
    },

    // 全部选中清除
    clearAllChecked() {
      this.$refs.xTable.setCheckboxRow(this.checkRows, false)
      this.checkRows = []
      this.getTableData()
    },

    // 清除
    clearChecked(row) {
      let temp = this.checkRows
      temp = temp.filter(item => row.id !== item.id)
      this.checkRows = temp
      this.$refs.xTable.setCheckboxRow([row], false)
      this.getTableData()
    },

    // 弹窗关闭
    dialogClose() {
      this.visiable = false
      this.$emit('update:visiable', this.visiable)
    }
  }
}
